import { Box, Breadcrumbs, Button, Typography } from '@mui/material';

import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { useEffect, useState } from 'react';
import { useNotify, useRedirect } from 'react-admin';
import { useParams } from 'react-router-dom';
import { Medication, UpdateMedicationPayload } from '../../../../interfaces/health-data';
import healthDataService from '../../../../services/health-data';
import { LoaderBubble } from '../../../common/LoaderBubble/LoaderBubble';
import { MedicationForm } from './MedicationForm/MedicationForm';

export const EditMedication = () => {
  const [medication, setMedication] = useState<Medication | null>(null);
  const [breadcrumbLabels, setBreadcrumbLabels] = useState<string[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const [form, setForm] = useState<UpdateMedicationPayload | null>(null);

  const notify = useNotify();
  const { medicationId } = useParams<{ medicationId: string }>();
  const redirect = useRedirect();

  const handleUpdateForm = ({
    internalGroupName,
    ndcCode,
    rxCuiCode,
    status,
    conceptName,
    additionalNdcCodes,
    additionalRxCuiCodes,
  }: UpdateMedicationPayload) =>
    setForm({
      ndcCode,
      status,
      rxCuiCode,
      conceptName,
      internalGroupName,
      additionalNdcCodes,
      additionalRxCuiCodes,
    });

  const handleSubmit = async () => {
    if (!form || !medication) {
      return;
    }

    const result = await healthDataService.updateMedication(medication.id, form);

    if (!result || !result.data || !result.data.medication) {
      notify('There was an error updating the medication', 'warning');
      return;
    }

    notify('Medication updated successfully');
    redirect(`/medical-setup/medications/${result.data.medication.id}/show`);
  };

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      const response = await healthDataService.getMedication(Number(medicationId));
      if (response && response.data) {
        setBreadcrumbLabels(['medications', response.data.medication.conceptName || 'Unknown']);
        setMedication(response.data.medication);
      }

      setIsLoading(false);
    })();
  }, [medicationId]);

  return (
    <Box>
      <Box display='flex' justifyContent='space-between' className='tab-section-action-bar'>
        <Breadcrumbs separator={<NavigateNextIcon fontSize='small' />}>
          {breadcrumbLabels.map((text, index) => {
            return (
              <Typography key={`text-medication-breadcrumb-${index}`} textTransform='capitalize'>
                {text}
              </Typography>
            );
          })}
        </Breadcrumbs>

        <Button
          onClick={handleSubmit}
          disabled={!form}
          variant='contained'
          sx={{ textTransform: 'capitalize' }}>
          Save
        </Button>
      </Box>

      {medication && !isLoading ? (
        <MedicationForm onChangeForm={handleUpdateForm} medication={medication} />
      ) : (
        <Box
          display='flex'
          alignItems='center'
          justifyContent='center'
          height='100%'
          width='100%'
          flexDirection='column'>
          <Typography mb={3}>Wait a few seconds...</Typography>
          <LoaderBubble />
        </Box>
      )}
    </Box>
  );
};
